import { rankWith, uiTypeIs } from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';

const GridTableView = () => {
  return (
    <div className="tru-layout-grid-table-view">
      <h3>Grid Table View (?)</h3>
    </div>
  );
};

export const GridTableViewEntry = {
  tester: rankWith(1, uiTypeIs('GridTableView')),
  renderer: withJsonFormsLayoutProps(GridTableView),
};
